export function showExpandButton(link) {
  if (link.hasMegaMenu) {
    return true;
  }

  if (!link.hasMegaMenu && link.children.length > 0) {
    return true;
  }

  return false;
}
